import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useVacancy } from '@services/query.service';

import './company-data-graph.styl';

function CompanyDataGraph() {
  const vacancy = useSelector(state => state.vacancy);
  const { companyId } = useParams();

  const OIDN = vacancy?.OIDN || companyId;
  const { data } = useVacancy(OIDN);

  const employeeInformation = data?.properties?.mobilityOffer?.employeeInformation;

  if (!employeeInformation) return null;

  const { 
    empl = 0,
    empl_bike: emplBike = 0, 
    empl_foot: emplFoot = 0, 
    empl_coll: emplColl = 0, 
    empl_train: emplTrain = 0, 
    empl_bus: emplBus = 0, 
  } = employeeInformation;

  const totalBikeFoot = emplBike + emplFoot;
  const totalBikeFootPercentage = (totalBikeFoot / empl) * 100;
  const totalPublicTransport = emplColl + emplTrain + emplBus;
  const totalPublicTransportPercentage = (totalPublicTransport / empl) * 100;

  if (totalBikeFoot === 0 && totalPublicTransport === 0) return null;

  function formatNumber(num) {
    return num % 1 === 0 ? num.toString() : num.toFixed(1);
  }

  return (
    <div className="company-data-graph">
      <div className="company-data-graph__header">
        <p className="company-data-graph__header__title">
          Op welke manier wordt hier gependeld?
        </p>
        <ul className="company-data-graph__header__legend">
          <li className="company-data-graph__header__legend__item">
            <span 
              className={(
                'company-data-graph__header__legend__item__color'
                + ' company-data-graph__header__legend__item__color--green'
              )}
            />
            fiets of te voet
          </li>
          <li className="company-data-graph__header__legend__item">
            <span 
              className={(
                'company-data-graph__header__legend__item__color'
                + ' company-data-graph__header__legend__item__color--blue'
              )}
            />
            openbaar vervoer
          </li>
          <li className="company-data-graph__header__legend__item">
            <span 
              className={(
                'company-data-graph__header__legend__item__color'
                + ' company-data-graph__header__legend__item__color--grey'
              )}
            />
            andere
          </li>
        </ul>
      </div>
      <div className="company-data-graph__bar">
        {totalBikeFootPercentage !== 0 && (
          <div className="company-data-graph__bar__green" style={{ width: `${totalBikeFootPercentage}%` }}>
            {`${formatNumber(totalBikeFootPercentage)}%`}
          </div>
        )}
        {totalPublicTransportPercentage !== 0 && (
          <div className="company-data-graph__bar__blue" style={{ width: `${totalPublicTransportPercentage}%` }}>
            {`${formatNumber(totalPublicTransportPercentage)}%`}
          </div>
        )}
      </div>
    </div>
  );
}

export default CompanyDataGraph;
